export default __webpack_public_path__ + "static/media/arrow.3aaca0b3.svg";